module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACWSURBVHgBzVLbDYAgDCzGMXQQdtAdWMs5cD/skZKAFDD+6CVE6D2oANFvEEJYeNgHOgttWk8Zt/JwTO4dMzgnWlWw8Ti0ENSE22jQYhXSM8/3gjHmZCGmu3wBGD24Sk+dThAiS9UMTNSGacwLzI3dsXNsW0rxd7gLPwzIzant/Ey0kMLcOu3eFSeBHd1zFmI18tVT/h4XegyT+D8EVfcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 1